<template>
    <section class="table-box">
        <CommonTable
            :data="VariableList"
            :config="config"
            :selected.sync="selected"
            :checkedrows.sync="checkedrows"
        >
            <template slot-scope="props"> 
                <b-table-column field="Name" :label="$t('app.dashboard.variable.cloudval')"  sortable style="cursor: default">
                    {{ props.row.Name }}
                </b-table-column>
                <b-table-column field="lastupdate" :label="$t('app.dashboard.variable.lastupdated')" sortable :custom-sort="sortByTime" style="cursor: default" >
                    {{ props.row.LatestData && lastModified(props.row.LatestData.Timestamp) }}
                </b-table-column>
                <b-table-column field="graph" :label="$t('app.dashboard.variable.graph')" width="15%" centered>
                    <div class="padding_top">
                        <b-icon style="cursor: pointer" icon="chart-areaspline" type="is-primary" />
                    </div>
                </b-table-column>
                <b-table-column v-if="Owned" field="delete" :label="$t('general.delete')" width="10%" centered>
                    <a @click="confirmCustomDelete(props.row.VariableID)" type="is-white">
                        <b-icon icon="delete" type="is-gray">
                        </b-icon>
                    </a>
                </b-table-column>
            </template>
        </CommonTable>
        <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import moment from 'moment'
    import CommonTable from '../../../view/CommonTable'
    export default {
        components: {CommonTable},
        props: {
            VariableList: {
                type: Array,
                required: true
            },
            Owned: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                config: {
                    defaultSort: ['lastupdate','desc'],
                    striped: true
                },
                checkedrows: [],
                selected: null,
                isLoading: false
            }
        },
        methods:{
             lastModified(time) {
                return moment(time).format('YYYY/MM/DD HH:mm:ss')
            },
            sortByTime(a, b, ord) {
                if (!a.LatestData && !b.LatestData)
                    return 0
                else if (!a.LatestData)
                    return 1
                else if (!b.LatestData)
                    return -1

                const a_ = moment(a.LatestData.Timestamp).valueOf()
                const b_ = moment(b.LatestData.Timestamp).valueOf()
                if (a_ == b_)
                    return 0
                else if (a_ > b_)
                    return ord? 1 : -1
                else
                    return ord? -1 : 1
            },
            sleep(msec) {
                return new Promise(function(resolve) {
                    setTimeout(function() {resolve()}, msec);
                })
            },
            async start() {
                await this.sleep(100);
                this.$store.dispatch('UpdateDelete',false)
                this.selected = null
            },
            confirmCustomDelete(vId) {
                this.$store.dispatch('UpdateDelete',true)
                this.$buefy.dialog.confirm({
                    title: this.$t("app.header.withdraw.title"),
                    message: this.$t("app.dashboard.variable.delete.warn_message"),
                    confirmText: 'Delete',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: async () => {
                        this.isLoading = true
                        await this.$store.dispatch('variables/deleteVariable', vId)
                        .then(() => this.$buefy.toast.open({
                            duration: 2000,
                            message: this.$t("app.dashboard.variable.delete.success"),
                            position: "is-top",
                            type: "is-success"
                        }))
                        .catch(() => { 
                            this.$buefy.toast.open({
                                duration: 7000,
                                message: this.$t('app.dashboard.graph.error_warning'),
                                position: "is-top",
                                type: "is-danger"
                            })
                            return Promise.resolve()
                        })
                        .finally(() => this.isLoading = false)
                    }
                })
                this.start()
            }
        },
        mounted(){
            this.$store.subscribe(mutation => {
                if (mutation.type === "UpdateSideCangeFlag") {
                    this.checkedrows = []
                }
            })
        },
        updated(){
            this.$store.dispatch('UpdateCheckedRows',this.checkedrows),
            this.$store.dispatch('UpdateSelected',this.selected)
        }
    }
</script>
<style scoped>
.table-box {
  width: 100%;
  background: #fff;
  margin: 35px 0;
  padding: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
